// Headers Components
import DefaultHeader from '../../../components/molecules/DefaultHeader/DefaultHeader';

/**
 * Helper function to render header by type
 * @param {ApiManagerTableColumns} apiColumn - API column
 * @returns {JSX.Element} Rendered header
 */
export const renderHeaderByType = (apiColumn) => {
  switch (apiColumn.type) {
    default:
      return <DefaultHeader title={apiColumn.lib}>{apiColumn.lib}</DefaultHeader>;
  }
};

/**
 * Stable TanStack header renderer. Identity must not change when column defs are rebuilt.
 * @param {import('@tanstack/react-table').HeaderContext<TableRowFlattened, unknown>} context
 * @returns {JSX.Element}
 */
export function TableColumnHeader({ column }) {
  const apiColumn = /** @type {TableColumnsReactTable} */ (column.columnDef);
  return renderHeaderByType(apiColumn);
}

export default renderHeaderByType;
